export enum AlertType {
    Info,
    Warning,
    Error
}

export interface IAlert {
    text: string;
    type: AlertType;
}